
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockTranDialog extends Serenity.EntityDialog<IcStockTranRow, any> {
        protected getFormKey() { return IcStockTranForm.formKey; }
        protected getIdProperty() { return IcStockTranRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockTranRow.localTextPrefix; }
        protected getNameProperty() { return IcStockTranRow.nameProperty; }
        protected getService() { return IcStockTranService.baseUrl; }
        protected getDeletePermission() { return IcStockTranRow.deletePermission; }
        protected getInsertPermission() { return IcStockTranRow.insertPermission; }
        protected getUpdatePermission() { return IcStockTranRow.updatePermission; }

        protected form = new IcStockTranForm(this.idPrefix);

    }
}